import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useChangePDAStatus = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const changePDAStatus = (payload, onSuccess, onError) => {
    setLoading(true);
    axiosClient
      .put(`InventoryAgent/ChengeStatus`, payload)
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`وضعیت با موفقیت تغییر کرد`, { variant: 'success' });
          onSuccess?.();
          setLoading(false);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
          onError?.();
          setLoading(false);
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
        onError?.();
        setLoading(false);
      })
      .finally(() => setLoading(false));
  };
  return { changePDAStatus, loading };
};

export default useChangePDAStatus;
